module.exports = __webpack_public_path__ + "img/send2.d331276c.png";